import { isValidElement } from "react";
import { createPortal } from "react-dom";
import type { AbsoluteProps } from "../Absolute";
import { Absolute } from "../Absolute";
import type { PortalProps } from "./Portal.types";

export const Portal = ({ children, container = globalThis?.document?.body }: PortalProps) => {
  if (!container || !isValidElement(children)) return null;

  return createPortal(children, container);
};

Portal.Absolute = ({ children, ...absoluteProps }: AbsoluteProps) => (
  <Portal>
    <Absolute {...absoluteProps}>{children}</Absolute>
  </Portal>
);
